import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { PointCardEditTemplate } from 'components/Templates'

const PointCardCreate: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const isEdit = /^\/point_card\/(?!create$)[^/]+$/.test(pathname)

  return (
    <Layout iconPath={'/icon/white/point_card.svg'} headline={'ポイントカード'} title={'ポイントカード'}>
      <PointCardEditTemplate isEdit={isEdit} />
    </Layout>
  )
}

export default PointCardCreate
